import React from 'react';

function ListItems({ value, handleClick }) {
  return (
    <div className="p-3 rounded-md bg-base-gray w-full flex justify-between items-center h-11">
      <p className="text-xs">{value?.name}</p>
      {value?.isAdded ? (
        <i
          className="las la-check-double text-success"
          style={{ fontSize: '1.2rem' }}
        ></i>
      ) : (
        <i
          className="las la-plus text-success cursor-pointer"
          style={{ fontSize: '1.2rem' }}
          onClick={() => handleClick(value)}
        ></i>
      )}
    </div>
  );
}

export default ListItems;
